<div class="remove-item-dialog">
  <!-- header -->
  <div class="border-bottom-lightest flex-between-center flex-row remove-item-header">
    <div class="flex-row flex-center">
      <span class="flex-center-center header-icon mr-2">
        <i class="fas fa-exclamation-triangle"></i>
      </span>
      <span class="font-18 font-700">Remove item</span>
    </div>
    <span class="close-icon">
      <i class="fal fa-times font-24 font-400 pointer" (click)="handleClose()"></i>
    </span>
  </div>

  <!-- body -->
  <div class="remove-item-body">
    <div class="flex-column w-100 font-400">
      <ng-container *ngFor="let item of items">
        <p class="m-0"  *ngIf="item?.itemSource === 'Nexpart'">
          Remove {{item?.title}} from service line.
        </p>
        <ng-container *ngIf="item?.itemSource !== 'Nexpart'">
          <p class="m-0">{{item?.title}}</p>
          <app-checkbox inputId="remove-item-1" fontSize="14" label="Remove from service line"
            [isChecked]="item?.removeFromServiceLine" [disabled]="item?.removeFromCart" (appChange)="
            handleChange(item, 'removeFromServiceLine' , $event)">
          </app-checkbox>

          <app-checkbox inputId="remove-item-1" fontSize="14" [isChecked]="item?.removeFromCart"
            label="Remove from {{source}} cart" [disabled]="item?.isOrdered"
            (appChange)="handleChange(item, 'removeFromCart', $event)">
          </app-checkbox>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <!-- Footer -->
  <div class="border-top-lightest flex-end-center remove-item-footer">
    <button id="remove-item-cancel-btn" class="btn btn-border mr-2" [disabled]="isProcessing" (click)="handleClose()">
      Cancel
    </button>

    <button id="remove-item-remove-btn" class="btn btn-primary" [disabled]="isProcessing" (click)="onRemoveItem()">
      Remove
      <i *ngIf="isProcessing" class="fal fa-spinner rotate ml-2"></i>
    </button>
  </div>
</div>
